import { useProfile } from 'init/use-enforce-profile';
import type { ReactNode } from 'react';
import { Redirect } from 'react-router-dom';
import { GROUP_OVERVIEW_FEATURE_FLAG } from 'shared/constants';
import { useAreFeatureFlagsLoaded, useIsFeatureFlagEnabled } from 'shared/utils/feature-flags';

export const GroupOverviewFlagGate = ({ children }: { children: ReactNode }) => {
  const areFeatureFlagsLoaded = useAreFeatureFlagsLoaded();
  const isGroupOverviewEnabled = useIsFeatureFlagEnabled(GROUP_OVERVIEW_FEATURE_FLAG);

  if (!areFeatureFlagsLoaded) return null;
  if (!isGroupOverviewEnabled) return <Redirect to="/dashboard" />;

  return children;
};

const GroupMemberGate = ({ children }: { children: ReactNode }) => {
  const { group } = useProfile();

  if (!group) return <Redirect to="/dashboard" />;

  return children;
};

export const GroupGate = ({ children }: { children: ReactNode }) => (
  <GroupOverviewFlagGate>
    <GroupMemberGate>{children}</GroupMemberGate>
  </GroupOverviewFlagGate>
);

export const useGroup = () => {
  const { group } = useProfile();

  if (!group) throw new Error('useGroup is only reachable behind GroupGate');

  return group;
};
